export const SORT_DIR = {ASC: 'asc', DESC: 'desc'} as const;
export type SortDir = (typeof SORT_DIR)[keyof typeof SORT_DIR];

export type SortOption = {
  id: string;
  label: string;
};

export const CONTENT_SUBMISSION_SORT = {
  KIND: 'kind',
  VERSIONS_COUNT: 'versions_count',
  AASM_STATE: 'aasm_state',
  OVERDUE: 'overdue',
  UPLOAD_DATE: 'upload_date',
} as const;

export type ContentSubmissionSort =
  (typeof CONTENT_SUBMISSION_SORT)[keyof typeof CONTENT_SUBMISSION_SORT];
